<script>
import Vue from 'vue';
import {mapState, mapGetters} from 'vuex';

export default Vue.extend({
    data() {
        return {
            collapseObject: undefined
        }
    },
    computed: {
        ...mapState({
            sites: state => state.contract.contract.item.arrivalRules.sites
        }),
        ...mapGetters({
            getContractCollapseObject: 'contract/getContractCollapseObject'
        })
    },
    created() {
        this.collapseObject = this.getContractCollapseObject;
    },
    methods: {
        collapse(obj) {
            if (obj.hasOwnProperty('accommodationIndex')) {
                this.collapseObject[obj.siteIndex].accommodations[obj.accommodationIndex] = !this.collapseObject[obj.siteIndex].accommodations[obj.accommodationIndex];
            } else {
                this.collapseObject[obj.siteIndex].collapse = !this.collapseObject[obj.siteIndex].collapse;
            }
            this.$forceUpdate();
        }
    },
});
</script>
<template>
    <div class="contract-form-arrival">
        <div class="contract-form-arrival__content">
            <div class="contract-form-arrival__header">
                <div class="contract-form-arrival__heading">
                    {{ $t('contract.form.arrivalRules.header.heading') }}
                </div>
            </div>
            <div class="contract-form-arrival__body">
                <div class="contract-form-arrival__items">
                    <div v-for="(site, siteIndex) in sites" :key="'site_' + siteIndex" class="contract-form-arrival__item contract-form-arrival__item-site">
                        <div :class="{'contract-form-arrival__item-header--collapsed': collapseObject[siteIndex].collapse}" class="contract-form-arrival__item-header" @click="collapse({siteIndex: siteIndex})">
                            <span>{{ site.name }}</span>
                            <span class="contract-form-arrival__item-header-info">{{ $t('contract.form.arrivalRules.arrival') }}: {{ site.arrival }}</span>
                            <span class="contract-form-arrival__item-header-info">{{ $t('contract.form.arrivalRules.departure') }}: {{ site.departure }}</span>
                        </div>
                        <div v-if="!collapseObject[siteIndex].collapse" >
                            <div v-for="(accommodation, accommodationIndex) in site.accommodations" :key="'accommodation_' + accommodationIndex" class="contract-form-arrival__item contract-form-arrival__item-accommodation">
                                <div :class="{'contract-form-discount__item-label--collapsed': collapseObject[siteIndex].accommodations[accommodationIndex]}" class="contract-form-arrival__item-label" @click="collapse({siteIndex: siteIndex, accommodationIndex: accommodationIndex})">
                                    {{ accommodation.name }}
                                </div>
                                <div v-if="!collapseObject[siteIndex].accommodations[accommodationIndex]" >
                                    <div v-for="(arrival, index) in accommodation.arrivals" :key="'arrival_' + index" class="contract-form-arrival__item contract-form-arrival__accommodation-row">
                                        <div class="contract-form-arrival__row-item">
                                            <div class="contract-form-arrival__row-label">{{ $t('contract.form.arrivalRules.startDate') }}</div>
                                            <div v-if="arrival.startDate" class="contract-form-arrival__item-date">{{ arrival.startDate | moment('DD/MM/YYYY') }}</div>
                                        </div>
                                        <div class="contract-form-arrival__row-item">
                                            <div class="contract-form-arrival__row-label">{{ $t('contract.form.arrivalRules.endDate') }}</div>
                                            <div v-if="arrival.endDate" class="contract-form-arrival__item-date">{{ arrival.endDate | moment('DD/MM/YYYY') }}</div>
                                        </div>
                                        <div class="contract-form-arrival__row-item">
                                            <div class="contract-form-arrival__row-label">{{ $t('contract.form.arrivalRules.minRental') }}</div>
                                            <div v-if="arrival.minRental" class="contract-form-arrival__item-date">{{ arrival.minRental }} {{ $t('contract.form.arrivalRules.days') }}</div>
                                        </div>
                                        <div class="contract-form-arrival__row-item">
                                            <div class="contract-form-arrival__row-label">{{ $t('contract.form.arrivalRules.maxRental') }}</div>
                                            <div v-if="arrival.maxRental" class="contract-form-arrival__item-date">{{ arrival.maxRental }} {{ $t('contract.form.arrivalRules.days') }}</div>
                                        </div>
                                        <div class="contract-form-arrival__row-item">
                                            <div class="contract-form-arrival__row-label">{{ $t('contract.form.arrivalRules.type.label') }}</div>
                                            <div v-if="arrival.type" class="contract-form-arrival__item-date">{{ $t('contract.form.arrivalRules.type.' + arrival.type) }}</div>
                                        </div>
                                        <div class="contract-form-arrival__row-item contract-form-arrival__item-days">
                                            <div class="contract-form-arrival__item-day">
                                                <div class="contract-form-arrival__row-label">{{ $t('contract.form.arrivalRules.weekdays.monday') }}</div>
                                                <div :class="['contract-form-arrival__checkbox', {'contract-form-arrival__checkbox--checked': arrival.monday}]"/>
                                            </div>
                                            <div class="contract-form-arrival__item-day">
                                                <div class="contract-form-arrival__row-label">{{ $t('contract.form.arrivalRules.weekdays.tuesday') }}</div>
                                                <div :class="['contract-form-arrival__checkbox', {'contract-form-arrival__checkbox--checked': arrival.tuesday}]"/>
                                            </div>
                                            <div class="contract-form-arrival__item-day">
                                                <div class="contract-form-arrival__row-label">{{ $t('contract.form.arrivalRules.weekdays.wednesday') }}</div>
                                                <div :class="['contract-form-arrival__checkbox', {'contract-form-arrival__checkbox--checked': arrival.wednesday}]"/>
                                            </div>
                                            <div class="contract-form-arrival__item-day">
                                                <div class="contract-form-arrival__row-label">{{ $t('contract.form.arrivalRules.weekdays.thursday') }}</div>
                                                <div :class="['contract-form-arrival__checkbox', {'contract-form-arrival__checkbox--checked': arrival.thursday}]"/>
                                            </div>
                                            <div class="contract-form-arrival__item-day">
                                                <div class="contract-form-arrival__row-label">{{ $t('contract.form.arrivalRules.weekdays.friday') }}</div>
                                                <div :class="['contract-form-arrival__checkbox', {'contract-form-arrival__checkbox--checked': arrival.friday}]"/>
                                            </div>
                                            <div class="contract-form-arrival__item-day">
                                                <div class="contract-form-arrival__row-label">{{ $t('contract.form.arrivalRules.weekdays.saturday') }}</div>
                                                <div :class="['contract-form-arrival__checkbox', {'contract-form-arrival__checkbox--checked': arrival.saturday}]"/>
                                            </div>
                                            <div class="contract-form-arrival__item-day">
                                                <div class="contract-form-arrival__row-label">{{ $t('contract.form.arrivalRules.weekdays.sunday') }}</div>
                                                <div :class="['contract-form-arrival__checkbox', {'contract-form-arrival__checkbox--checked': arrival.sunday}]"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="sites.length === 0" class="contract-form-site__no-content">
                <i class="fa fa-bullhorn"/>
                <div class="manage-allocation-list__no-content-message">{{ $t('contract.form.arrivalRules.noContent') }}</div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ContractFormArrival/ContractFormArrival.vue